//components
import {
  Kicker,
  KickerDot,
  SectionTitle,
  Grad,
} from '@/containers-ai/SectionHeading';
import { Container } from '@/components/Grid';

//theme
import { homeColor } from '@/theme/ai';

//styles
import {
  StackSection,
  StackWrap,
  StackDescription,
  DiagramWrap,
  DiagramSvg,
} from './RunsOnYourStack.styles';

export function RunsOnYourStack({ content }) {
  const rowY = [50, 110, 170];
  const integrations = [
    { key: 'API', copy: content.diagram.integrations.api },
    { key: 'EDI', copy: content.diagram.integrations.edi },
    { key: 'MCP', copy: content.diagram.integrations.mcp },
  ];

  return (
    <StackSection>
      <Container>
        <StackWrap>
          <Kicker>
            <KickerDot />
            {content.kicker}
          </Kicker>
          <SectionTitle style={{ maxWidth: 'none' }}>
            {content.title}
            <Grad>{content.titleHighlight}</Grad>
          </SectionTitle>
          <StackDescription>{content.description}</StackDescription>
        </StackWrap>
        <DiagramWrap>
          <DiagramSvg
            viewBox="0 0 1000 220"
            role="img"
            aria-label={content.diagram.ariaLabel}
          >
            <rect
              x="0"
              y="70"
              width="180"
              height="80"
              rx="10"
              fill={homeColor.surface2}
              stroke={homeColor.cyan}
              strokeWidth="1.9"
            />
            <text
              x="90"
              y="102"
              textAnchor="middle"
              fontFamily="Manrope,system-ui,sans-serif"
              fontWeight="700"
              fontSize="11"
              fill="#FCFCFF"
            >
              {content.diagram.sorLine1}
            </text>
            <text
              x="90"
              y="116"
              textAnchor="middle"
              fontFamily="Manrope,system-ui,sans-serif"
              fontWeight="700"
              fontSize="11"
              fill="#FCFCFF"
            >
              {content.diagram.sorLine2}
            </text>
            <text
              x="90"
              y="134"
              textAnchor="middle"
              fontFamily="Manrope,system-ui,sans-serif"
              fontWeight="500"
              fontSize="11"
              fill={homeColor.muted2}
            >
              {content.diagram.sorSub}
            </text>

            <rect
              x="820"
              y="70"
              width="180"
              height="80"
              rx="10"
              fill={homeColor.surface}
              stroke={homeColor.cyan}
              strokeWidth="1.9"
            />
            <text
              x="910"
              y="112"
              textAnchor="middle"
              fontFamily="Manrope,system-ui,sans-serif"
              fontWeight="700"
              fontSize="16"
              fill="#fff"
            >
              {content.diagram.agentTitle}
            </text>
            <text
              x="910"
              y="130"
              textAnchor="middle"
              fontFamily="Manrope,system-ui,sans-serif"
              fontWeight="500"
              fontSize="10"
              fill={homeColor.green}
            >
              {content.diagram.agentSub}
            </text>

            {integrations.map((row, index) => {
              const y = rowY[index];
              return (
                <g key={row.key}>
                  <line
                    x1="200"
                    y1={y}
                    x2="800"
                    y2={y}
                    stroke={homeColor.muted2}
                    strokeWidth="1"
                    strokeDasharray="3 4"
                    opacity="0.6"
                  />
                  <circle cx="200" cy={y} r="3.5" fill={homeColor.muted2} />
                  <circle cx="800" cy={y} r="3.5" fill={homeColor.muted2} />
                  <rect
                    x="270"
                    y={y - 15}
                    width="460"
                    height="30"
                    rx="15"
                    fill={homeColor.bg}
                    stroke="rgba(0,215,215,0.4)"
                    strokeWidth="1"
                  />
                  <text
                    x="292"
                    y={y + 4}
                    fontFamily="Manrope,system-ui,sans-serif"
                    fontWeight="600"
                    fontSize="11"
                    fill={homeColor.green}
                  >
                    {row.key}
                  </text>
                  <text
                    x="330"
                    y={y + 4}
                    fontFamily="Manrope,system-ui,sans-serif"
                    fontWeight="500"
                    fontSize="11"
                    fill={homeColor.muted}
                  >
                    {row.copy}
                  </text>
                </g>
              );
            })}
          </DiagramSvg>
        </DiagramWrap>
      </Container>
    </StackSection>
  );
}
